<template>
  <div class="no-vacancies-card">
    <img src="../assets/no_vacancies.png" alt="No vacancies" class="no-vacancies-image" />
    <p class="no-vacancies-text">У нас пока что нет<br />открытых вакансий данной компании</p>
  </div>
</template>

<style scoped>

.no-vacancies-card {
  max-width: 342px;
  height: 360px;
  margin-top: 14px;
  margin-left: 10px;
  padding: 0px 24px;
  border-radius: 24px;
  text-align: center;
}

.no-vacancies-image {
  margin-top: 80px;
  width: 110px;
  height: 100px;
  margin-bottom: 20px;
}

.no-vacancies-text {
  margin-left: 40px;
  margin-right: 40px;
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  font-family: "Eastman-Regular", sans-serif;
  color: var(--text-color, #222);
}


[data-theme="dark"] .no-vacancies-text {
  color: #fff;
}

</style>